import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from "react";
import './LeadsUpdatedVersion.css';
import axios from "axios";

const RatingEditComponent = ({ inquiryId, mark, initialRating, initialRateMessage, updateLead }) => {
    const [rating, setRating] = useState(initialRating || 0);
    const [hover, setHover] = useState(0);
    const [submitted, setSubmitted] = useState(!!initialRateMessage);
    const [showOptions, setShowOptions] = useState(false);
    const [checkRating, setCheckRating] = useState(false);
    const url=API_BASE_URL

    // useEffect(() => {
    //     if (rating > 0) {
    //         const timer = setTimeout(() => {
    //             setShowOptions(true); // Show options after 3 seconds
    //         }, 500);
    //         return () => clearTimeout(timer); // Cleanup timeout
    //     }
    // }, [rating]);

    useEffect(() => {
        setRating(initialRating || 0);
        setShowOptions(false);  // Always reset on modal open
        setSubmitted(false);    // Allow updating rating even if previously submitted
    }, [initialRating, initialRateMessage]);


    const handleStarClick = async (star) => {
        setRating(star);
        setHover(0);     // 🧹 Clear any hover effect
        setShowOptions(true); // 🎯 Show radio options immediately
        setSubmitted(false);

        try {
            const response = await axios.put(`${url}/leads/change/${inquiryId}`, {
                rating: star
            });
            
            if (response.status === 200) {
                updateLead(inquiryId, { rating: star });
            }

        } catch (error) {
            console.error("Error updating rating:", error);
        }
    };


    const handleSelection = async (option) => {
        try {
            const response = await axios.put(`${url}/leads/change/${inquiryId}`, {
                rate_message: option
            });
            
            if (response.status === 200) {
                updateLead(inquiryId, { rate_message: option });
                setSubmitted(true);
            }


        } catch (error) {
            console.error("Error updating rate message:", error);
        }
    };
    // const fetchSingleRating = async () => {
    //     try {
    //         const response = await fetch(`${url}/leads/${inquiryId}`);
    //         const res = await response.json();
    //         ;
    //         if (res.rating && res.rate_message) {
    //             setCheckRating(true)
    //         }else{
    //             setCheckRating(false);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // }

    // useEffect(() => {
    //     fetchSingleRating();
    // }, [inquiryId])

    return (
        <div className="rating-container crm-enquiry-rating">
            <span className="crm-enquiry-rating__prompt">How useful was this enquiry?</span>

            {/* Show Stars Only if Options Are Not Visible */}
            {!submitted && !showOptions && (
                <div className="stars crm-enquiry-rating__stars">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <i
                            key={star}
                            className={`fa-star ${star <= (hover || rating) ? "fas" : "far"} ${mark !== "Read" ? "disabled" : ""}`}
                            onMouseEnter={() => mark === "Read" && setHover(star)}
                            onMouseLeave={() => mark === "Read" && setHover(0)}
                            onClick={() => mark === "Read" && handleStarClick(star)}
                        ></i>
                    ))}

                </div>

            )}

            {/* Show Radio Options After 3-sec Delay */}
            {rating > 0 && showOptions && !submitted && (
                <>
                    {rating <= 3 && (
                        <div className="radio-options crm-enquiry-rating__options">
                            {["Not Interested", "Not Contactable", "Wrong category", "Out of area", "Marketing/Job"].map(
                                (option) => (
                                    <div key={option}>
                                        <input
                                            type="radio"
                                            id={`rating-edit-${inquiryId}-${option.replace(/\s+/g, "-")}`}
                                            name={`feedback-edit-${inquiryId}`}
                                            value={option}
                                            onChange={() => handleSelection(option)}
                                        />
                                        <label
                                            className="crm-enquiry-rating__option"
                                            htmlFor={`rating-edit-${inquiryId}-${option.replace(/\s+/g, "-")}`}
                                        >
                                            {option}
                                        </label>
                                    </div>
                                )
                            )}
                        </div>
                    )}

                    {rating >= 4 && (
                        <div className="radio-options crm-enquiry-rating__options">
                            {["Great Enquiry", "High Potential", "Close to Conversion"].map(
                                (option) => (
                                    <div key={option}>
                                        <input
                                            type="radio"
                                            id={`rating-edit-${inquiryId}-${option.replace(/\s+/g, "-")}`}
                                            name={`feedback-edit-${inquiryId}`}
                                            value={option}
                                            onChange={() => handleSelection(option)}
                                        />
                                        <label
                                            className="crm-enquiry-rating__option"
                                            htmlFor={`rating-edit-${inquiryId}-${option.replace(/\s+/g, "-")}`}
                                        >
                                            {option}
                                        </label>
                                    </div>
                                )
                            )}
                        </div>
                    )}
                </>
            )}

            {/* Thank You Message */}
            {submitted && (
                <div className="thank-you">
                    <p>Thank you for your feedback! We appreciate it.</p>
                </div>
            )}
        </div>
    );
};

export default RatingEditComponent;
